'use strict';

import React from 'react';
import WarningMessage from '../_utils/warning-message';

import LocationFormatter from './location-formatter';
import genericHelpers from '../_utils/generic-helpers';

const OutOfStockWarning = ({
  alternateStore,
  productMessage,
  setStoreToAlternate,
}) => {
  return (
    <WarningMessage
      className="bleed-warning store-unavailable-warning"
      dataTestId="store-unavailable-error"
      hidePrefix>
      <b>We're sorry:</b> {productMessage}
      <br aria-hidden="true" />
      {prompts()}
    </WarningMessage>
  );

  function prompts() {
    if (!alternateStore) {
      return ['Please select a different store, or choose Home Delivery.'];
    }

    let { name: storeName } = new LocationFormatter(alternateStore);
    const {
      distance: { miles: storeDistanceMiles },
    } = alternateStore;

    storeName = genericHelpers.capitalizeWordsInString(storeName);

    return [
      `Your closest store with availability is ${storeName}, ${storeDistanceMiles} miles away. `,
      <a
        role="button"
        href="#"
        key="change"
        data-test-id="change-store"
        onClick={setStoreToAlternate}>
        Click to change to that location.
      </a>,
    ];
  }
};

OutOfStockWarning.displayName = 'OutOfStockWarning';

export default OutOfStockWarning;
